module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide",
      "appear": ""
    }
  }, [(_vm.data) ? _c('div', {
    staticClass: "app-content-body fade-in-up content-transition"
  }, [_c('div', {
    staticClass: "hbox hbox-auto-xs hbox-auto-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "r"
  }, [(_vm.isPreenchidoAutomaticamente) ? _c('div', {
    staticClass: "bg-warning lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h4 text-black"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  }), _vm._v(" "), _c('strong', [_vm._v("Atenção")]), _c('br'), _vm._v("\n                  Os campos foram preenchidos automaticamente com base nos dados "), _c('strong', [_vm._v(_vm._s(_vm.origemDadosAutoPreenchimento))]), _vm._v(".\n                  "), _c('br'), _vm._v("\n                  É recomendado conferir os dados antes de confirmar.\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', [_c('form', {
    staticClass: "bs-example form-horizontal form-grv",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submit($event)
      }
    }
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                          Retirada\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 m-t-md"
  }, [(_vm.data.codigoInfracao === '4.32') ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Este veículo possui multa DETRO, favor consultar antes de realizar a liberação")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao registrar a retirada, corrija e tente novamente\n                        ")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-danger btn-md m-t",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openVisualizacaoPendencias
    }
  }, [_vm._v("Ver pendências do veículo com a DETRO")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-md m-t",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submit(null, true)
      }
    }
  }, [_vm._v("Cadastrar retirada mesmo assim")])])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group lbl-form"
  }, [_c('label', {
    staticClass: "col-sm-2"
  }, [_vm._v("GRV")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10 font-bold"
  }, [_vm._v("\n                          " + _vm._s(_vm.data.numero) + " - " + _vm._s(_vm.isGrvPoliciaCivil ? _vm.data.placaOriginal : _vm.data.placa) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "status"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.status),
      expression: "retirada.status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "status",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.retirada, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione")]), _vm._v(" "), _vm._l((_vm.statusList), function(status, index) {
    return _c('option', {
      key: index,
      attrs: {
        "disabled": status.disabled
      },
      domProps: {
        "value": index
      }
    }, [_vm._v(_vm._s(status.titulo) + "\n                            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "dataPrevista"
    }
  }, [_vm._v("Data da retirada")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.dataRetirada),
      expression: "retirada.dataRetirada"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##/##/####'),
      expression: "'##/##/####'"
    }],
    ref: "dataRetirada",
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "dataPrevista",
      "type": "text",
      "placeholder": "dd/mm/yyyy"
    },
    domProps: {
      "value": (_vm.retirada.dataRetirada)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.retirada, "dataRetirada", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('label', {
    staticClass: "i-checks"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.multaDetroPaga),
      expression: "retirada.multaDetroPaga"
    }],
    attrs: {
      "type": "checkbox",
      "tabindex": "0",
      "aria-checked": "false",
      "aria-invalid": "false"
    },
    domProps: {
      "checked": Array.isArray(_vm.retirada.multaDetroPaga) ? _vm._i(_vm.retirada.multaDetroPaga, null) > -1 : (_vm.retirada.multaDetroPaga)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.retirada.multaDetroPaga,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.retirada, "multaDetroPaga", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.retirada, "multaDetroPaga", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.retirada, "multaDetroPaga", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('i'), _vm._v(" Multa DETRO foi paga\n                          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('h1', {
    staticClass: "font-thin h3"
  }, [_vm._v("\n                          Dados de quem está retirando o veículo\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Nome")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.nome),
      expression: "retirada.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "nome",
      "type": "text",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.retirada.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.retirada, "nome", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("Tipo documento")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.tipoDocumento),
      expression: "retirada.tipoDocumento"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "disabled": _vm.isDesabilitarCampos
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.retirada, "tipoDocumento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 1
    }
  }, [_vm._v("CPF")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("CNPJ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Matrícula")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "numeroDocumento"
    }
  }, [_vm._v("Número documento")]), _vm._v(" "), (_vm.retirada.tipoDocumento === 1) ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.cpf),
      expression: "extraModel.cpf"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###.###.###-##'),
      expression: "'###.###.###-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "numeroDocumento",
      "type": "text",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.extraModel.cpf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "cpf", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.retirada.tipoDocumento === 2) ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.cnpj),
      expression: "extraModel.cnpj"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('##.###.###/####-##'),
      expression: "'##.###.###/####-##'"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "numeroDocumento",
      "type": "text",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.extraModel.cnpj)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "cnpj", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.retirada.tipoDocumento === 3) ? _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.extraModel.matricula),
      expression: "extraModel.matricula"
    }],
    staticClass: "form-control",
    attrs: {
      "autocomplete": "off",
      "required": "",
      "id": "numeroDocumento",
      "type": "text",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.extraModel.matricula)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.extraModel, "matricula", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "numeroRg"
    }
  }, [_vm._v("Número do RG")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.numeroRg),
      expression: "retirada.numeroRg"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "numeroRg",
      "type": "text",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.retirada.numeroRg)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.retirada, "numeroRg", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "endereco"
    }
  }, [_vm._v("Endereço")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.endereco),
      expression: "retirada.endereco"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "endereco",
      "type": "text",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.retirada.endereco)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.retirada, "endereco", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.isGrvPoliciaCivil) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "autoDeEntrega"
    }
  }, [_vm._v("Auto de Entrega")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.autoDeEntrega),
      expression: "retirada.autoDeEntrega"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('###-#####/####'),
      expression: "'###-#####/####'"
    }],
    ref: "autoDeEntrega",
    staticClass: "form-control",
    attrs: {
      "required": "",
      "id": "autoDeEntrega",
      "type": "text",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.retirada.autoDeEntrega)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.retirada, "autoDeEntrega", $event.target.value)
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label",
    attrs: {
      "for": "observacao"
    }
  }, [_vm._v("Observações")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.retirada.observacao),
      expression: "retirada.observacao"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "observacao",
      "rows": "8",
      "disabled": _vm.isDesabilitarCampos
    },
    domProps: {
      "value": (_vm.retirada.observacao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.retirada, "observacao", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn-success btn-md m-l-xs",
    attrs: {
      "disabled": _vm.isDesabilitarCampos
    }
  }, [_vm._v("Registrar Retirada")])])])])])])])])])])]), _vm._v(" "), (_vm.showVisualizacaoPendencias) ? _c('popup-viewer', {
    attrs: {
      "title": "Pendências do Veículo"
    },
    on: {
      "close": _vm.closeVisualizacaoPendencias
    }
  }, [_c('VisualizarPendenciasVeiculo', {
    attrs: {
      "tipoDocumentoLiberacao": _vm.retirada.tipoDocumento,
      "documentoLiberacao": _vm.numeroDocumento,
      "grv": _vm.$route.params.id
    }
  })], 1) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b52edca","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/retirada/components/addRetirada.vue
// module id = 1489
// module chunks = 17